import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="new-asset-modal"
export default class extends Controller {
  static targets = ["newPdfButton", "newVideoButton", "newAudioButton"]
  connect() {
  }
}
